import React from 'react';
import PropTypes from 'prop-types';
import Pronunciation from '../pronunciation';

export default class Header extends React.Component {

  static propTypes = {
    wordText: PropTypes.string,
    pronunciationFile: PropTypes.string,
    partOfSpeech: PropTypes.string
  }

  render() {
    return(
      <div className='word-title-underline'>
        <h2 className='word-title'>
          { this.props.wordText }
          <Pronunciation wordText={ this.props.wordText } pronunciationFile={ this.props.pronunciationFile }  />
        </h2>
        <div className='pull-in-5 part-of-speech'>
          <i>{ this.props.partOfSpeech }</i>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/word/header.jsx